import Medusa from '@adoratorio/medusa';

// targets


const medusa = {
  ref: null,

  init() {
    medusa.ref = new Medusa({
      targets: [],
    });
  },

  intersectingTarget: [],
};

export default medusa;
